import './product-overview.scss';
import axios from 'axios';

class ProductOverview {
    constructor (element, options) {
        const defaults = {
            initAttr: 'data-product-overview',
            onSubmit: null,
            loader: null
        };
        this.settings = Object.assign({}, defaults, options);

        this.$productOveriew = element;
        this.$productOveriewContent = document.querySelector('[data-product-overview="content"]');
        this.$filterLoader = this.$productOveriew.querySelector('.loader__item');

        this.initialize();
    }

    initialize () {
        this.setEvents();
    }

    // set events initial
    setEvents () {
        this.$productOveriewForm = this.$productOveriew.querySelector('[data-product-filter="form"]');
        this.$productOveriewLoadMore = this.$productOveriew.querySelector('[data-product-overview="load"]');
        this.$productOveriewSpinner = this.$productOveriew.querySelector('[data-spinner]');

        this.$productOveriewForm.addEventListener('submit', () => {
            this.showSpinner();
        });

        if (this.$productOveriewLoadMore) {
            this.$productOveriewLoadMoreUrl = this.$productOveriew.querySelector('[data-product-overview="load"]').href;
            this.$productOveriewLoadMore.addEventListener('click', (e) => {
                e.preventDefault();
                this.showSpinner();
                this.loadMoreProducts(this.$productOveriewLoadMoreUrl);
            });
        }
    }

    loadMoreProducts (url) {
        axios.get(url)
            .then(response => {
                const responseHtml = new DOMParser().parseFromString(response.data, 'text/html');
                const newContent = responseHtml.querySelector('[data-product-overview="content"]');

                if (newContent) {
                    const contentElement = this.$productOveriewContent;
                    contentElement.innerHTML = newContent.innerHTML;
                    this.setEvents();
                    this.hideSpinner();

                    const loadMoreEvent = new CustomEvent('change', {
                        view: window,
                        bubbles: true,
                        cancelable: false
                    });

                    this.$productOveriew.dispatchEvent(loadMoreEvent);

                    if (typeof this.settings.onSubmit === 'function') {
                        this.settings.onSubmit(this.$productOveriewContent);
                    }
                }
            })
            .catch(error => {
                console.error('An error occurred:', error);
            });
    }

    hideSpinner () {
        if (this.$filterLoader) this.$filterLoader.hidden = true;
    }

    showSpinner () {
        if (this.$filterLoader) this.$filterLoader.hidden = false;

        window.addEventListener('pageshow', (event) => {
            if (event.persisted) {
                if (this.$filterLoader) this.$filterLoader.hidden = true;
            }
        });
    }
}

export { ProductOverview };
